module.exports = __webpack_public_path__ + "img/default@2x.7514ce73.png";